e4.quickorder = {
    init: function () {
        if ( jQuery( '.js-e-quickorder' ).length === 1 || jQuery( '.js-eldorado-quickorder-nav-item' ).length > 0 ) {
            e4.require.js( e4.settings.require.typeahead, function () {
                e4.require.js( e4.settings.require.jQueryValidate, function () {
                    e4.require.js( e4.settings.require.handlebars, function () {
                        e4.handlebars.registerHelpers( 'compare' );
                        e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-bulkorder-results-row #js-e-handlebars-tmpl-bulkorder-results' );
                        e4.quickorder.bindEvents();
                    } );
                } );
            } );
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-quickorder-form' ).validate( {} );
        jQuery( '.js-eldorado-quickorder-nav-item' ).on( 'click', function ( event ) {
            event.preventDefault();
            jQuery( '.modal' ).modal( 'hide' );
            jQuery( '#js-eldorado-quickorder-modal' ).modal( 'show' );
        } );

        jQuery( '.js-eldorado-bulkorder-modal-btn' ).on( 'click', function ( event ) {
            event.preventDefault();
            jQuery( '.modal' ).modal( 'hide' );
            jQuery( '#js-eldorado-bulkorder-modal' ).modal( 'show' );
        } );

        jQuery( '.js-eldorado-quickorder-modal-btn' ).on( 'click', function ( event ) {
            event.preventDefault();
            jQuery( '.modal' ).modal( 'hide' );
            jQuery( '#js-eldorado-quickorder-modal' ).modal( 'show' );
        } ); 
        
        jQuery('.js-eldorado-bulkorder-modal').on('input', '.js-bulkorder-input-quantity', e4.util.debounce(function ( event ){
            let jElement = jQuery(event.currentTarget),
                jRowElement = jElement.closest( '.js-eldorado-bulkorder-productline-item' ),
                productQuantity = jElement.val(),
                productColli = jElement.attr('step'),
                modifiedQuantity = e4.quickorder.getPackageCalculatedQuantity(jRowElement, productQuantity, productColli);
            jRowElement.find( '.js-bulkorder-input-quantity' ).val(modifiedQuantity)
        }, 300));

        /*jQuery( '.js-eldorado-bulkorder-input' ).on( 'keydown', function ( event ) {
            if ( event.keyCode === 13 ) {
                event.preventDefault();
                jQuery('.js-eldorado-bulkorder-productlist-table').addClass('d-none');
                let objData              = [],
                    textareaContentLines = jQuery( event.currentTarget ).val(),
                    paramNumbers         = [];
                jQuery.each( textareaContentLines.split( /\n/ ), function ( intIndex, textareaContentLine ) {
                    textareaContentLine = Math.random()+';'+textareaContentLine.toUpperCase();
                    let textareaContentLineParts = textareaContentLine.split( ';' );
                    objData.push( textareaContentLineParts );
                    paramNumbers.push( textareaContentLineParts[ 1 ] );
                } );
                
                jQuery( '.js-eldorado-bulkorder-productlist' ).html( e4.handlebars.tmpl.bulkorderResults( objData ) );
                e4.quickorder.populateBulkProductListWithProductsByNumbers( paramNumbers.join( ',' ) );
                jQuery( event.currentTarget).val('');
                e4.quickorder.toggleBulkAddToCartButton();
            }
        } );*/

        jQuery( '.js-eldorado-bulkorder-input' ).on( 'input', function ( event ) {
                event.preventDefault();
                jQuery('.js-eldorado-bulkorder-productlist-table').addClass('d-none');
                let objData              = [],
                    textareaContentLines = jQuery( event.currentTarget ).val(),
                    paramNumbers         = [];
                jQuery.each( textareaContentLines.split( /\n/ ), function ( intIndex, textareaContentLine ) {
                    if ( textareaContentLine.length > 0 ){
                        textareaContentLine = textareaContentLine.toUpperCase();
                        let encodedTextareaContentLine = encodeURI(textareaContentLine);
                        textareaContentLine = encodedTextareaContentLine.split('%09').join(';');
                        textareaContentLine = Math.random()+';'+decodeURI(textareaContentLine);
                        let textareaContentLineParts = textareaContentLine.split( ';' );
                        objData.push( textareaContentLineParts );
                        paramNumbers.push( textareaContentLineParts[ 1 ] );
                    }
                } );
                jQuery( '.js-eldorado-bulkorder-productlist' ).html( e4.handlebars.tmpl.bulkorderResults( objData ) );
                e4.quickorder.populateBulkProductListWithProductsByNumbers( paramNumbers.join( ',' ) );
                jQuery( event.currentTarget).val('');
                e4.quickorder.toggleBulkAddToCartButton();
        } );

        jQuery( '#js-eldorado-quickorder-modal' ).on( 'shown.bs.modal', function ( event ) {
            e4.quickorder.clear();
            jQuery( event.currentTarget ).find( '.js-e-quickorder-input' ).focus().trigger( 'focus' );
        } );

        jQuery('#js-eldorado-bulkorder-modal').on('click', '.js-eldorado-bulkorder-reset', function( event ){
            event.preventDefault();
            jQuery( '.js-eldorado-bulkorder-productlist' ).empty();
            jQuery( '.js-eldorado-bulkorder-input').val('');
            jQuery('.js-eldorado-bulkorder-productlist-table').addClass('d-none');
            e4.quickorder.toggleBulkAddToCartButton();
        }).on('click', '.js-eldorado-bulkorder-add-row', function( event ){
            event.preventDefault();
            let objData = {
                0: Math.random(),
                1: '',
                2: '1',
                3: ''
            };
            jQuery( '.js-eldorado-bulkorder-productlist' ).append( e4.handlebars.tmpl.bulkorderResultsRow( objData ) );
            jQuery('.js-eldorado-bulkorder-productlist-table').removeClass('d-none');
            jQuery('.js-eldorado-bulkorder-productlist-table').scrollTop(jQuery('.js-eldorado-bulkorder-productlist-table')[0].scrollHeight);
            e4.quickorder.toggleBulkAddToCartButton();
        }).on('click', '.js-bulkorder-line-delete', function(event){
            event.preventDefault();
            jQuery(event.currentTarget).closest('.js-eldorado-bulkorder-productline-item').remove();
            e4.quickorder.toggleBulkAddToCartButton();
        }).on( 'shown.bs.modal', function ( event ) {
            jQuery( event.currentTarget ).find( '.js-eldorado-bulkorder-input' ).val( '' ).focus().trigger( 'focus' );
        } ).on('input', '.js-bulkorder-input-number', function( event ){
                event.preventDefault();
                e4.quickorder.repopulateBulkRowWithProductsByNumbers(jQuery(event.currentTarget));
        }).on('click', '.js-eldorado-bulkorder-add-to-cart', function( event ){
            event.preventDefault();
            let postData = {},
            allQuantityInputIsValid = true;
            postData['CartCmd'] = 'addmulti';
            postData[ 'OrderContext' ] = eldorado.contextcart;
            jQuery('.js-eldorado-bulkorder-productline-item:not(.bg-danger)').each(function(intIndex, domElement){
                const jElement = jQuery( domElement );
                if ( jElement.find('.js-bulkorder-input-quantity').valid() ) {
                    postData[ 'ProductLoopCounter' + intIndex ] = intIndex;
                    postData[ 'ProductID' + intIndex ] = jElement.data( 'productId' );
                    postData[ 'VariantID' + intIndex ] = jElement.data( 'variantId' );
                    postData[ 'UnitID' + intIndex ] = '';
                    postData[ 'Quantity' + intIndex ] = jElement.find( '.js-bulkorder-input-quantity' ).val();
                    postData[ 'EcomOrderLineFieldInput_Comment' + intIndex ] = jElement.find( '.js-bulkorder-input-comment' ).val();
                } else {
                    allQuantityInputIsValid = false;
                }
            });
            
            if(allQuantityInputIsValid){
                e4.cart.addProduct(postData);
                jQuery('.js-eldorado-bulkorder-reset').trigger('click');
            }
        });

        jQuery( '.js-e-quickorder-form' ).on( 'submit', function ( event ) {
            event.preventDefault();
            const jSuggestionFirst = jQuery( this ).find( '.js-e-quickorder-suggestions' ).find( '.tt-selectable' ).first();
            if ( jSuggestionFirst.length === 1 ) {
                jSuggestionFirst.trigger( 'click' );
            }
        } ).on( 'click', '.js-e-quickorder-submit', function () {
            jQuery( this.form ).triggerHandler( 'submit' );
        } );

        jQuery( '.js-e-cart' ).on( 'updated.e4.cart', function () {
            e4.quickorder.focus();
        } );

        jQuery( '.js-eldorado-quickorder-input-quantity' ).on( 'keydown', function ( event ) {
            if ( event.keyCode === 13 ) {
                event.preventDefault();
                event.stopPropagation();
                const jInput = jQuery( event.currentTarget );
                e4.quickorder.addQuickToCart(jInput);
            }
        } );
        
        jQuery('.js-eldorado-quickorder-add-to-cart').on('click', function(event){
            e4.quickorder.addQuickToCart(jQuery( '.js-eldorado-quickorder-input-quantity' ));
        });

        jQuery( '.js-e-quickorder-input' ).on( 'keydown', function ( event ) {
            if ( event.keyCode === 13 ) {
                var jSuggestions      = jQuery( event.target.form ).find( '.js-e-quickorder-suggestions' ),
                    jSuggestionActive = jSuggestions.find( '.tt-selectable' ).filter( '.active' );
                if ( jSuggestionActive.length === 0 && jSuggestions.css( 'display' ) === 'block' ) {
                    jQuery( this.form ).triggerHandler( 'submit' );
                }
            }
        } ).typeahead( {
            hint: true,
            highlight: true,
            minLength: e4.settings.search.inputMinLength,
            classNames: {
                wrapper: 'e-quickorder-typeahead-wrapper js-e-quickorder-typeahead-wrapper w-100',
                input: 'js-e-quickorder-input',
                menu: 'js-e-quickorder-suggestions e-quickorder-suggestions position-relative border-0 shadow-none dropdown-menu w-100',
                suggestion: 'js-e-quickorder-suggestions-item dropdown-item px-1',
                open: 'open',
                cursor: 'active',
                highlight: 'active'
            }
        }, {
            name: 'espresso',
            display: function ( suggestion ) {
                let strLine = '';
                strLine += suggestion.Number + ' ' + suggestion.Name;
                if ( suggestion.VariantName.length > 0 ){
                    strLine += ' ' + suggestion.VariantName;
                }
                if ( suggestion.Color.length > 0 ){
                    strLine += ' Farve:' + suggestion.Color;
                }
                if ( suggestion.Color.length > 0 ){
                    strLine += ' Størrelse:' + suggestion.Size;
                }
                return strLine;
            },
            limit: 8,
            async: true,
            source: e4.util.debounce( function ( query, syncResults, asyncResults ) {
                e4.quickorder.getSuggestions( query, function ( products ) {
                    asyncResults( products );
                } );
            }, e4.settings.debounceDelay.input )
        } ).on( 'typeahead:autocomplete typeahead:select', function ( event, product ) { // typeahead:cursorchange
            if ( product !== null ) {
                if ( jQuery( event.currentTarget ).closest( '#js-eldorado-quickorder-modal' ).length > 0 ) {
                    e4.quickorder.productdata[ 'ProductID' ] = product.Id;
                    e4.quickorder.productdata[ 'VariantID' ] = product.VariantId;
                    
                    let productColli = product.Colli < 1 ? 1 : product.Colli;
                    
                    jQuery(event.currentTarget).closest('.js-e-quickorder-input').val(product.Number + ' ' + product.Name);
                    jQuery( event.currentTarget ).closest( '#js-eldorado-quickorder-modal' ).find( '.js-eldorado-quickorder-input-quantity' ).val(productColli).attr('min', productColli).attr('step', productColli).trigger( 'focus' ).select();
                    
                    e4.quickorder.toggleQuickAddToCartButton(); 
                    
                }
                else {
                    e4.quickorder.addProduct( product );
                    jQuery( this ).typeahead( 'close' );
                }
            }
        } );
    },
    addQuickToCart: function(jInput){
        if ( jInput.valid() ) {
            e4.quickorder.productdata[ 'Quantity' ] = jInput.val();
            e4.quickorder.productdata[ 'OrderContext' ] = eldorado.contextcart;
            e4.cart.addProduct( e4.quickorder.productdata );
            e4.quickorder.clear();
            jQuery( '.js-eldorado-quickorder-input-quantity' ).val( '' );
            e4.quickorder.productdata = {};
            jQuery( '#js-eldorado-quickorder-modal' ).find( '.js-e-quickorder-input').val('');
            jQuery( '#js-eldorado-quickorder-modal' ).find( '.js-e-quickorder-input' ).focus().trigger( 'focus' );
            jInput.removeClass( 'is-invalid' );
            jInput.closest( '.form-group' ).removeClass( 'is-invalid' );
            e4.quickorder.toggleQuickAddToCartButton();
        }
    },
    productdata: {},
    getSuggestions: function ( query, asyncResults ) {
        if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
            this.jqXHR.abort();
        }
        query = jQuery.trim( query );
        if ( query !== '' ) {
            this.jqXHR = jQuery.ajax( {
                method: 'GET',
                url: e4.settings.ecom.quickorder.url,
                data: {
                    searchQuery: query,
                    productNumbers: ''
                },
                dataType: 'json'
            } );
            this.jqXHR.done( function ( data ) {
                asyncResults( data.Products );
            } );
        }
    },
    populateBulkProductListWithProductsByNumbers: function ( numbers ) {
        if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
            this.jqXHR.abort();
        }
        numbers = jQuery.trim( numbers );
        if ( numbers !== '' ) {
            this.jqXHR = jQuery.ajax( {
                method: 'GET',
                url: e4.settings.ecom.quickorder.url,
                data: {
                    searchQuery: '',
                    productNumbers: numbers
                },
                dataType: 'json'
            } );
            this.jqXHR.done( function ( data ) {
                jQuery.each(data.Products, function(intIndex, objProduct){
                    let jRowElement = jQuery( '.js-eldorado-bulkorder-productline-item[data-number="' + objProduct.Number + '"]' );
                    if ( jRowElement.length === 0 ){
                        jRowElement = jQuery( '.js-eldorado-bulkorder-productline-item[data-number="' + objProduct.EAN + '"]' );
                    }
                    
                    if ( jRowElement.length > 0 ){
                        jRowElement.removeClass('bg-danger text-danger');
                        let strFieldNameContent = '<span class="d-block">' + objProduct.Name + '</span>';
                        if ( objProduct.VariantName.length > 0 ){
                            strFieldNameContent += '<span class="pr-1 small text-muted">' + objProduct.VariantName + '</span>';
                        } else if ( objProduct.Color.length > 0 ){
                            strFieldNameContent += '<span class="pr-1 small"><span class="text-muted">Color:</span> ' + objProduct.Color + '</span>';
                        } else if ( objProduct.Size.length > 0 ){
                            strFieldNameContent += '<span class="pr-1 small"><span class="text-muted">Size:</span> ' + objProduct.Size + '</span>';
                        }
                        
                        jRowElement.find('[data-field="name"]').html(strFieldNameContent);
                        jRowElement.data('productId', objProduct.Id);
                        jRowElement.data('variantId', objProduct.VariantId);
                        
                        let productColli = objProduct.Colli < 1 ? 1 : objProduct.Colli;
                        let productQuantity = jRowElement.find( '.js-bulkorder-input-quantity' ).val();
                        productQuantity = productQuantity.length === 0 ? 1 : productQuantity*1;
                        
                        let modifiedQuantity = e4.quickorder.getPackageCalculatedQuantity(jRowElement, productQuantity, productColli);
                        jRowElement.find( '.js-bulkorder-input-quantity' ).val(modifiedQuantity).attr('min', productColli).attr('step', productColli);
                    }
                });
                jQuery('.js-eldorado-bulkorder-productlist-table').removeClass('d-none');
                e4.quickorder.toggleBulkAddToCartButton();
            } );
        }
    },
    getPackageCalculatedQuantity: function(jRowElement, productQuantity, productColli){
        let returnValue = Math.round(productQuantity / productColli) * productColli;
        returnValue = returnValue === 0 ? productColli : returnValue;
        e4.quickorder.updateColliBadge(jRowElement, productQuantity, productColli, returnValue);
        return returnValue;
    },
    updateColliBadge: function(jRowElement, productQuantity, productColli, modifiedQuantity){
        jRowElement.find('.js-eldorado-mismatch-colli-badge').remove();
        if ( productQuantity*1 !== modifiedQuantity*1){
            jRowElement.find('[data-field="name"]').html(jRowElement.find('[data-field="name"]').html()+'<span style="white-space: normal;border-radius: .5em;" class="js-eldorado-mismatch-colli-badge badge badge-discount badge-pill d-inline-flex mt-1 px-2">'+jRowElement.data('colliMismatchText').replace('[[quantity]]', productQuantity).replace('[[modifiedquantity]]', modifiedQuantity).replace('[[colli]]', productColli)+'</span>');
        }
    },
    toggleBulkAddToCartButton: function(){
        var hasboolBulkOrderlines = jQuery('.js-eldorado-bulkorder-productline-item:not(.bg-danger)').length > 0;
        if ( hasboolBulkOrderlines ){
            jQuery('.js-eldorado-bulkorder-add-to-cart').removeClass('disabled');
        } else {
            jQuery('.js-eldorado-bulkorder-add-to-cart').addClass('disabled');
        }
        jQuery('.js-eldorado-bulkorder-add-to-cart').prop('disabled', !hasboolBulkOrderlines);
    },
    toggleQuickAddToCartButton: function(){
        let boolBuyAllowed = (e4.quickorder.productdata['ProductID'] !== undefined && jQuery('.js-eldorado-quickorder-input-quantity').val() !== '');
        if ( boolBuyAllowed ){
            jQuery('.js-eldorado-quickorder-add-to-cart').prop('disabled', false).removeClass('disabled')
        } else {
            jQuery('.js-eldorado-quickorder-add-to-cart').prop('disabled', true).addClass('disabled')
        }
    },
    repopulateBulkRowWithProductsByNumbers: function ( jInput ) {
        if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
            this.jqXHR.abort();
        }
        let numbers = jQuery.trim( jInput.val() );
        if ( numbers !== '' ) {
            this.jqXHR = jQuery.ajax( {
                method: 'GET',
                url: e4.settings.ecom.quickorder.url,
                data: {
                    searchQuery: '',
                    productNumbers: numbers
                },
                dataType: 'json'
            } );
            this.jqXHR.done( function ( data ) {
                let jRowElement = jInput.closest( '.js-eldorado-bulkorder-productline-item' );
                jRowElement.data('number', numbers);
                if ( data.Products.length === 0 ){
                    jRowElement.addClass('bg-danger text-danger');
                    jRowElement.find('[data-field="name"]').text(jRowElement.data('noResultName'));
                    jRowElement.data('productId','');
                    jRowElement.data('variantId', '');
                } else {
                    jQuery.each(data.Products, function(intIndex, objProduct){
                        if ( jRowElement.length > 0 ){
                            jRowElement.removeClass('bg-danger text-danger');
                            let strFieldNameContent = '<span class="d-block">' + objProduct.Name + '</span>';
                            if ( objProduct.VariantName.length > 0 ){
                                strFieldNameContent += '<span class="pr-1 small text-muted">' + objProduct.VariantName + '</span>';
                            } else if ( objProduct.Color.length > 0 ){
                                strFieldNameContent += '<span class="pr-1 small"><span class="text-muted">Color:</span> ' + objProduct.Color + '</span>';
                            } else if ( objProduct.Size.length > 0 ){
                                strFieldNameContent += '<span class="pr-1 small"><span class="text-muted">Size:</span> ' + objProduct.Size + '</span>';
                            }
                            
                            jRowElement.find('[data-field="name"]').html(strFieldNameContent);
                            jRowElement.data('productId', objProduct.Id);
                            jRowElement.data('variantId', objProduct.VariantId);
                            let productColli = objProduct.Colli < 1 ? 1 : objProduct.Colli;

                            jRowElement.find( '.js-bulkorder-input-quantity' ).val(productColli).attr('min', productColli).attr('step', productColli);
                        }
                    });
                }
                e4.quickorder.toggleBulkAddToCartButton();
            } );
        }
    },
    focus: function () {
        if ( jQuery( '.js-e-quickorder' ).length > 0 ) {
            var jQuickorder = jQuery( '.js-e-quickorder' ),
                intTarget   = Math.ceil( jQuickorder.offset().top - jQuery( window ).height() + jQuickorder.height() + e4.scrollToAnchor.getNudge() );
            e4.scrollToAnchor.animate( intTarget, function () {
                if ( jQuery( document.activeElement ).is( '.js-e-orderline-quantity-input' ) !== true ) {
                    jQuickorder.find( '.js-e-quickorder-input' ).focus();
                }
            } );
        }
    },
    clear: function () {
        jQuery( '.js-e-quickorder-input' ).typeahead( 'val', '' );
    },
    addProduct: function ( objProduct ) {
        e4.cart.addProduct( {
            ProductID: objProduct.id,
            VariantID: objProduct.variantId
        } );
        e4.quickorder.clear();
    }
};
